<template>
  <ion-app>
    <Menu></Menu>
    <ion-router-outlet id="main-content"/>
  </ion-app>
</template>

<script>
import { IonApp, IonRouterOutlet, menuController } from '@ionic/vue';
import { defineComponent } from 'vue';
import Menu from './components/Menu.vue';//Added 221122
import EventBus from "./common/EventBus";//Added 24-04-09 for RefreshToken https://www.bezkoder.com/vue-3-refresh-token/

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet,
    Menu //Added 221122
  },
  //Added 2024-04-09 RefreshToken
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      // Ensure side menu is closed when navigating back to login
      menuController.close('app-menu');
      this.$router.push('/tunes');
    }
  },
  mounted() {
    EventBus.on("logout", () => {
      this.logOut();
    });
  },
  //beforeDestroy() {
  beforeUnmount() { //Added since beforeDestroy seems deprecated 2024-04-10
    EventBus.remove("logout");
  }
  //End 2024-04-09 RefreshToken
});
</script>